// Tamanhos para as fontes da aplicação.
const fonts = {
    bigger: 24,
    big: 18,
    regular: 14,
    small: 12,
    smaller: 11,
};

export default fonts;
